import Relay from "@/relay/relayUtils"
import DiscoScrolledIntoView from "@disco-ui/scrolled-into-view/DiscoScrolledIntoView"
import DiscoMultiSelectFilters, {
  DiscoMultiSelectFiltersProps,
} from "@disco-ui/select/DiscoMultiSelectFilters"
import DiscoSpinner from "@disco-ui/spinner/DiscoSpinner"
import { TestIDProps } from "@utils/typeUtils"
import classNames from "classnames"
import React from "react"
import classes from "./DiscoMultiSelectListbox.module.css"

interface Props<T extends string>
  extends TestIDProps,
    React.HTMLAttributes<HTMLElement>,
    DiscoMultiSelectFiltersProps<T> {
  pagination?: Relay.RefetchablePagination
  search?: string
}

function DiscoMultiSelectListbox<T extends string>({
  pagination,
  search,
  selectedFilter,
  setFilter,
  filters,
  ...listboxProps
}: Props<T>) {
  // If there are no filters or pagination, just render the default listbox
  if (!filters?.length && !pagination) {
    return (
      <ul
        {...listboxProps}
        role={"listbox"}
        className={classNames(listboxProps.className, classes.items)}
      >
        {listboxProps.children}
      </ul>
    )
  }

  return (
    <div
      {...listboxProps}
      className={classNames(listboxProps.className, classes.listbox)}
    >
      {Boolean(filters?.length) && (
        <DiscoMultiSelectFilters
          filters={filters}
          selectedFilter={selectedFilter}
          setFilter={setFilter}
        />
      )}

      <ul role={"listbox"}>
        <div
          className={classNames(classes.items, {
            [classes.hasFilters]: Boolean(filters?.length),
          })}
        >
          {listboxProps.children}

          {pagination && pagination.hasNext && (
            <DiscoScrolledIntoView
              isLoading={pagination.isLoading}
              onScrolledIntoView={() => pagination.loadMore({ search })}
              skeleton={<DiscoSpinner />}
            />
          )}
        </div>
      </ul>
    </div>
  )
}

export default DiscoMultiSelectListbox
